import { render, staticRenderFns } from "./AppSelector.vue?vue&type=template&id=2a9832d7&scoped=true&"
import script from "./AppSelector.vue?vue&type=script&lang=ts&"
export * from "./AppSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppSelector.vue?vue&type=style&index=0&id=2a9832d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9832d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VList,VListItem,VListItemGroup,VListItemTitle,VMenu,VTextField})
